import { useState } from "react";
import { Flex, Box, Button, Switch } from "@chakra-ui/react";
import time from "src/utils/time";
import { useTranslation } from "react-i18next";
import debug from "src/modules/debug-logger";
import Dialog from "src/components/Dialog";
import GenericFailureDialog from "src/components/GenericFailureDialog";
import { H3 } from "src/atoms/typography";
import Modal from "src/components/Modal";
import TextField from "src/components/TextField";
import { hourInMs, minuteInMs } from "src/utils/time/constants";

export default function LullabyPlayerTimerSettings({
  onClose,
  onSubmit,
  duration = 60 * 1000,
  enabled
}) {
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [localEnabled, setLocalEnabled] = useState(enabled);
  const [playerTime, setPlayerTime] = useState(
    time("2020-07-27 00:00:00").add(duration)
  );

  function getTimeInMilliseconds() {
    const duration = time(playerTime).format("HH:mm", { hour12: false });
    const hours = Number(duration.split(":")[0]);
    const minutes = Number(duration.split(":")[1]);
    return hours * hourInMs + minutes * minuteInMs;
  }

  const localDuration = getTimeInMilliseconds();

  async function submitHandler(e) {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      await onSubmit({
        enabled: localEnabled,
        duration: localDuration
      });
      setIsSubmitting(false);
      onClose();
    } catch (error) {
      debug.lullaby("TimerSettings update failed", error);
      setHasError(true);
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <Modal isOpen={true}>
        <Box as="form" width="280px" onSubmit={submitHandler}>
          <Box px="24px" pt="24px">
            <Flex mb="24px" alignItems="center" justifyContent="space-between">
              <H3 color="highEmphasis">{t("timer")}</H3>
              <Switch
                isChecked={localEnabled}
                onChange={() => setLocalEnabled((enabled) => !enabled)}
              />
            </Flex>
            <Flex justifyContent="center">
              <TextField
                type="time"
                elevationLevel={1}
                disabled={!localEnabled}
                label={t("lullaby.timer.label")}
                value={playerTime.format("HH:mm", { hour12: false })}
                inputProps={{ min: "00:01" }}
                onChange={(e) => {
                  const hour = Number(e.target.value.split(":")[0]);
                  const minute = Number(e.target.value.split(":")[1]);
                  setPlayerTime(time().set({ hour, minute }));
                }}
              />
            </Flex>
          </Box>
          <Flex mt="24px" px="8px" pb="8px" justifyContent="flex-end">
            <Button
              variant="flatPrimary"
              type="button"
              minWidth="80px"
              onClick={onClose}
            >
              {t("buttons.cancel")}
            </Button>
            <Button
              var="flatPrimary"
              disabled={localEnabled && localDuration < 60 * 1000}
              type="submit"
              minWidth="80px"
              ml="8px"
            >
              {t("buttons.ok")}
            </Button>
          </Flex>
        </Box>
        <Dialog isOpen={isSubmitting} isProcessing={true} />
        <GenericFailureDialog
          isOpen={hasError}
          onDismiss={() => setHasError(false)}
        />
      </Modal>
    </>
  );
}
